window.SiteReady(($) => {

  let $window = $(window);
  let $body = $('body');
  let mouseY;

  $body.on('mouseleave', (e) => {
    mouseY = e.clientY;

    if (mouseY < 0) {
      console.log('Exit Intent');
      $window.trigger('exitintent');
    }
  });

});